import { Icon } from '@chakra-ui/react';

const CustomDownloadPageIcon = (props) => (
  <Icon viewBox="0 0 34 30" width="32px" height="32px" fill="none" {...props}>
    <path
      className="strokeBrandElToDark darkBgElToBrand"
      d="M14.0016 7.5V16.6M14.0016 16.6L17.9016 12.7M14.0016 16.6L10.1016 12.7"
      stroke="#FFFFFF"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      className="strokeBrandElToDark darkBgElToBrand"
      d="M19.2008 20.5H8.80078"
      stroke="#FFFFFF"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      className="strokeBrandElToDark darkBgElToBrand"
      d="M1 14C1 7.8718 1 4.8077 2.9032 2.9032C4.809 1 7.8718 1 14 1C20.1282 1 23.1923 1 25.0955 2.9032C27 4.809 27 7.8718 27 14C27 20.1282 27 23.1923 25.0955 25.0955C23.1936 27 20.1282 27 14 27C7.8718 27 4.8077 27 2.9032 25.0955C1 23.1936 1 20.1282 1 14Z"
      stroke="#FFFFFF"
      stroke-width="1.5"
    />
  </Icon>
);

export default CustomDownloadPageIcon;
